import * as React from 'react'

import ReactDOM from 'react-dom'

export interface IPageBadgesProps {}

export const PageBadges = ({
  children,
}: React.PropsWithChildren<IPageBadgesProps>) => {
  const [pageBadgeContainer, setPageBadgeContainer] =
    React.useState<Element | null>(null)

  React.useEffect(() => {
    setPageBadgeContainer(document.querySelector('#page-badge-container'))
  }, [])

  return pageBadgeContainer ? (
    ReactDOM.createPortal(children, pageBadgeContainer)
  ) : (
    <>{children}</>
  )
}

PageBadges.displayName = 'PageBadges'
